import React from "react";

function SimplData() {
  return (
    <>
      <h1 className="headingCard">ERP</h1>
      <div className="cardItems">
        <div className="cardleftitmes">
            <div>Up Time</div>
            <span>99.98%</span>
        </div>
        <div className="cardrightitmes">Active</div>
      </div>
      {/* next card */}
      <h1 className="nextHeadingTag">
        SIMPL <span>Powered by NPCI UPMS</span>
      </h1>
      <div className="nextCard">
        <div>Total Amount</div>
        <span>₹150,000</span>
      </div>
    </>
  );
}

export default SimplData;
